import React, { createContext, useContext, useReducer } from "react";

const CartContext = createContext();

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD": {
      const id = String(action.productId);
      const existingIdx = state.findIndex(item => item.productId === id);
      if (existingIdx !== -1) {
        const newState = [...state];
        newState[existingIdx].quantity = Math.min(newState[existingIdx].quantity + action.quantity, 10);
        return newState;
      }
      return [...state, { productId: id, quantity: action.quantity }];
    }
    case "REMOVE":
      return state.filter(item => item.productId !== String(action.productId));
    case "UPDATE":
      return state.map(item =>
        item.productId === String(action.productId)
          ? { ...item, quantity: action.quantity }
          : item
      );
    case "CLEAR":
      return [];
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [cart, dispatch] = useReducer(cartReducer, []);

  const addToCart = (productId, quantity = 1) => dispatch({ type: "ADD", productId: String(productId), quantity });
  const removeFromCart = (productId) => dispatch({ type: "REMOVE", productId: String(productId) });
  const updateCartItem = (productId, quantity) => dispatch({ type: "UPDATE", productId: String(productId), quantity });
  const clearCart = () => dispatch({ type: "CLEAR" });

  return (
    <CartContext.Provider value={{ cart, addToCart, removeFromCart, updateCartItem, clearCart }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
